type ItemWithPriority = {
  priority: number | null;
};
export default function sortByPriority(
  a: ItemWithPriority,
  b: ItemWithPriority
) {
  return (a.priority ?? 0) - (b.priority ?? 0);
}
